import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  /* SLTF The Silver Editorial - WOFF2 (optimized from OTF, ~70% smaller) */
  @font-face { font-family: 'SLTFTheSilverEditorial'; src: url('/fonts/SLTFTheSilverEditorial-Regular.woff2') format('woff2'); font-weight: 400; font-style: normal; font-display: swap; }
  @font-face { font-family: 'SLTFTheSilverEditorial'; src: url('/fonts/SLTFTheSilverEditorial-Medium.woff2') format('woff2'); font-weight: 500; font-style: normal; font-display: swap; }
  @font-face { font-family: 'SLTFTheSilverEditorial'; src: url('/fonts/SLTFTheSilverEditorial-SemiBold.woff2') format('woff2'); font-weight: 600; font-style: normal; font-display: swap; }
  @font-face { font-family: 'SLTFTheSilverEditorial'; src: url('/fonts/SLTFTheSilverEditorial-Bold.woff2') format('woff2'); font-weight: 700; font-style: normal; font-display: swap; }
  @font-face { font-family: 'SLTFTheSilverEditorial'; src: url('/fonts/SLTFTheSilverEditorial-ExtraBold.woff2') format('woff2'); font-weight: 800; font-style: normal; font-display: swap; }

  :root {
    font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    line-height: 1.5;
    font-weight: 400;

    color-scheme: light dark;
    color: rgba(255, 255, 255, 0.87);
    background-color: #F6F6F6;

    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #F6F6F6;
  }

  body {
    font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  * {
    box-sizing: border-box;
  }

  /* Disable tap highlight globally on mobile */
  * {
    -webkit-tap-highlight-color: transparent;
  }

  /* Mobile touch handling improvements */
  @media (max-width: 768px) {
    body {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-y: contain;
    }
    
    /* Prevent text selection on drag interactions */
    [data-dragging='true'] {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  /* Prevent body scroll when autocomplete is active on mobile */
  body.autocomplete-active {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
    
    @media (max-width: 768px) {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
    }
  }
`;
